import React from "react";

function LocationMap() {
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <iframe
        title="location-map"
        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDrPSNUf_6iI95MrqwlcT7njNrt6rU0CAE&q=Դավիթաշեն,+4-րդ+թաղ,+41/8,+Yerevan,+Armenia"
        width="100%"
        height="300px"
        style={{ display: "block", margin: "0 auto", padding: 0, border: "none",border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default LocationMap;
